export const ARROW_SIZE = 10;
export const TOP_ARROW_CLASS = 'top-arrow';
export const BOTTOM_ARROW_CLASS = 'bottom-arrow';
export const RIGHT_ARROW_CLASS = 'right-arrow';
export const LEFT_ARROW_CLASS = 'left-arrow';
export const DEFAULT_ARROW_CLASS = 'bottom-arrow';

/* Tooltip actions */
export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';